import { render, staticRenderFns } from "./IconFolderClosed.vue?vue&type=template&id=78dc12c4&scoped=true"
import script from "./IconFolderClosed.vue?vue&type=script&lang=js"
export * from "./IconFolderClosed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78dc12c4",
  null
  
)

export default component.exports